import React from 'react';
import { useRootWorkplaceByChildQuery } from '../../../../../graphql/graphql';
import { useAppContext } from '../../../../../Services/AppContext';
import WorkplaceWorkersList from './WorkplaceWorkersList';
import Loading from '../../../../../Components/Loading';

interface Props {
	showAllWorkplaces: boolean;
}

const WorkplaceWorkersListWrapper: React.FC<Props> = ({
	showAllWorkplaces,
}) => {
	const rootWorkplace = useRootWorkplaceByChildQuery({
		workplaceId: useAppContext().workplaceId,
	});

	const rootWorkplaceData = rootWorkplace?.data?.workplace?.rootWorkplace;

	if (rootWorkplace.isLoading || !rootWorkplaceData?.id) {
		return <Loading />;
	}

	return (
		<WorkplaceWorkersList
			showAllWorkplaces={showAllWorkplaces}
			rootWorkplace={{
				id: rootWorkplaceData?.id,
				name: rootWorkplaceData?.name,
				address: rootWorkplaceData?.address?.fullAddress,
			}}
		/>
	);
};

export default WorkplaceWorkersListWrapper;
